import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { IPageChange } from '@bcl/design-system';
import { HttpClient } from '@angular/common/http';
import { ChatsListPage } from './chat-list.component';
import { environment } from 'src/environments';

@Injectable()
export class ChatListService {
  private readonly chatsUrl = `${environment.apiHost}/mobile/v1.0/visit-chats`;

  constructor(private http: HttpClient) {}

  public getChatsPage(page: IPageChange<unknown>): Observable<ChatsListPage> {
    return this.http.get<ChatsListPage>(`${this.chatsUrl}/page`, {
      params: { pageNumber: page.pageNumber, pageSize: page.pageSize },
    });
  }

  public hasUnreadChats(): Observable<boolean> {
    return this.http
      .get<{ hasUnreadChats: boolean }>(`${this.chatsUrl}/any-unread`)
      .pipe(map((response) => response.hasUnreadChats));
  }
}
